import jwtDecode from 'jwt-decode';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var MAX_VALUE = 4294967295;
var getRandomNumber = function () {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions
    if (((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues) && window.Uint32Array) {
        getRandomNumber = function () {
            return window.crypto.getRandomValues(new Uint32Array(1))[0] / MAX_VALUE;
        };
    }
    else {
        getRandomNumber = function () { return Math.random(); };
    }
    return getRandomNumber();
};
function getRandomInt(min, max) {
    var ceiledMin = Math.ceil(min);
    var flooredMax = Math.floor(max);
    return (Math.floor(getRandomNumber() * (flooredMax - ceiledMin + 1)) + ceiledMin);
}

var OidcTokenBase = /** @class */ (function () {
    function OidcTokenBase(token) {
        var _this = this;
        this.toString = function () { return _this.token; };
        this.getClaim = function (claim) { return _this.tokenObject[claim]; };
        this.token = token;
        this.tokenObject = jwtDecode(this.token);
    }
    return OidcTokenBase;
}());

var OidcAccessToken = /** @class */ (function (_super) {
    __extends(OidcAccessToken, _super);
    function OidcAccessToken(token) {
        var _this = _super.call(this, token.replace(/^Bearer /, '')) || this;
        _this.toString = function () { return "Bearer " + _this.token; };
        return _this;
    }
    return OidcAccessToken;
}(OidcTokenBase));

var OidcIdToken = /** @class */ (function (_super) {
    __extends(OidcIdToken, _super);
    function OidcIdToken() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.preferredUsername = _this.getClaim('urn:oriflame:activeDirectory:preferred_username');
        _this.name = _this.getClaim('name');
        return _this;
    }
    return OidcIdToken;
}(OidcTokenBase));

var TEST = 'test';
var isSessionStorageSupported = function () {
    try {
        sessionStorage.setItem(TEST, TEST);
        sessionStorage.removeItem(TEST);
        isSessionStorageSupported = function () { return true; };
        return isSessionStorageSupported();
    }
    catch (error) {
        isSessionStorageSupported = function () { return false; };
        return isSessionStorageSupported();
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/prefer-function-type
function singleton(Constructor) {
    return /** @class */ (function (_super) {
        __extends(Singleton, _super);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function Singleton() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = this;
            if (Singleton.instance instanceof Singleton) {
                // eslint-disable-next-line no-constructor-return
                return Singleton.instance;
            }
            _this = _super.apply(this, args) || this;
            Singleton.instance = _this;
            // eslint-disable-next-line no-constructor-return
            return _this;
        }
        return Singleton;
    }(Constructor));
}

var isSessionStorageAvailable = isSessionStorageSupported();
var SessionStorage = /** @class */ (function () {
    function SessionStorage() {
    }
    SessionStorage.prototype.getItem = function (key) {
        if (!(key !== '' && isSessionStorageAvailable)) {
            return null;
        }
        var value = sessionStorage.getItem(key);
        if (value === null) {
            return null;
        }
        try {
            return JSON.parse(value);
        }
        catch (error) {
            // NOOP
        }
        return value;
    };
    SessionStorage.prototype.setItem = function (key, value) {
        if (key !== '' && isSessionStorageAvailable) {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        return this;
    };
    SessionStorage.prototype.removeItem = function (key) {
        if (key !== '' && isSessionStorageAvailable) {
            sessionStorage.removeItem(key);
        }
        return this;
    };
    SessionStorage.prototype.clearItems = function (prefix) {
        if (prefix !== '' && isSessionStorageAvailable) {
            Object.keys(sessionStorage)
                .filter(function (keyName) { return keyName.indexOf(prefix, 0) === 0; })
                .forEach(function (key) { return sessionStorage.removeItem(key); });
        }
    };
    SessionStorage = __decorate([
        singleton
    ], SessionStorage);
    return SessionStorage;
}());

var SessionValue = /** @class */ (function () {
    function SessionValue(key) {
        var _this = this;
        this.storage = new SessionStorage();
        this.remove = function () {
            _this.storage.removeItem(_this.key);
            return _this;
        };
        this.get = function () {
            return _this.storage.getItem(_this.key);
        };
        this.set = function (value) {
            _this.storage.setItem(_this.key, value);
            return _this;
        };
        this.key = key;
    }
    return SessionValue;
}());

var OidcTokenStorage = /** @class */ (function () {
    function OidcTokenStorage() {
        var _this = this;
        this.accessToken = new SessionValue(OidcTokenStorage_1.ACCESS_TOKEN_PARAM);
        this.idToken = new SessionValue(OidcTokenStorage_1.ID_TOKEN_PARAM);
        this.state = new SessionValue(OidcTokenStorage_1.STATE_PARAM);
        this.nonce = new SessionValue(OidcTokenStorage_1.NONCE_PARAM);
        this.getAccessToken = function () {
            var token = _this.accessToken.get();
            if (token !== null) {
                return new OidcAccessToken(token);
            }
            return null;
        };
        this.setAccessToken = function (oidcToken) {
            _this.accessToken.set(oidcToken.toString());
            return _this;
        };
        this.getIdToken = function () {
            var token = _this.idToken.get();
            if (token !== null) {
                return new OidcIdToken(token);
            }
            return null;
        };
        this.setIdToken = function (oidcIdToken) {
            _this.idToken.set(oidcIdToken.toString());
            return _this;
        };
    }
    OidcTokenStorage_1 = OidcTokenStorage;
    var OidcTokenStorage_1;
    OidcTokenStorage.ACCESS_TOKEN_PARAM = 'AuthToken';
    OidcTokenStorage.ID_TOKEN_PARAM = 'AuthIdToken';
    OidcTokenStorage.STATE_PARAM = 'AuthState';
    OidcTokenStorage.NONCE_PARAM = 'AuthNonce';
    OidcTokenStorage = OidcTokenStorage_1 = __decorate([
        singleton
    ], OidcTokenStorage);
    return OidcTokenStorage;
}());

var RANDOM_NUMBER_LOWER_BOUND = 1;
var RANDOM_NUMBER_UPPER_BOUND = Math.pow(2, 32); // eslint-disable-line @typescript-eslint/no-magic-numbers
var OidcClient = /** @class */ (function () {
    function OidcClient(params, oAuthParams) {
        var _this = this;
        this.storage = new OidcTokenStorage();
        this.doLogin = function () {
            var state = "S" + getRandomInt(RANDOM_NUMBER_LOWER_BOUND, RANDOM_NUMBER_UPPER_BOUND) + Date.now();
            var nonce = "N" + getRandomInt(RANDOM_NUMBER_LOWER_BOUND, RANDOM_NUMBER_UPPER_BOUND) + Date.now();
            _this.storage.state.set(state);
            _this.storage.nonce.set(nonce);
            var encodedRedirectUrl = encodeURIComponent(_this.params.redirectUrl);
            var baseUrl = location.protocol + "//" + location.host + "/" + _this.params.callbackUrl;
            var redirectUri = baseUrl + "?redirectUrl=" + encodedRedirectUrl + "&";
            var url = new URL(_this.oAuthParams.identityUrl + "/identity/connect/authorize");
            url.search = new URLSearchParams({
                nonce: nonce,
                state: state,
                acr_values: _this.oAuthParams.acrValues,
                client_id: _this.oAuthParams.clientId,
                prompt: 'login',
                redirect_uri: redirectUri,
                response_type: 'id_token token',
                scope: _this.oAuthParams.scope,
            }).toString();
            window.location.href = url.href;
        };
        this.params = params;
        this.oAuthParams = oAuthParams;
    }
    OidcClient = __decorate([
        singleton
    ], OidcClient);
    return OidcClient;
}());

var OidcUrlHelper = /** @class */ (function () {
    function OidcUrlHelper() {
        var _this = this;
        this.ACCESS_TOKEN = 'access_token';
        this.ID_TOKEN = 'id_token';
        this.storage = new OidcTokenStorage();
        this.storeTokenFromParams = function (params) {
            _this.validateParams(params);
            var oidcToken = new OidcAccessToken(params.get(_this.ACCESS_TOKEN));
            _this.storage.setAccessToken(oidcToken);
            var oidcIdToken = new OidcIdToken(params.get(_this.ID_TOKEN));
            _this.validateIdToken(oidcIdToken);
            _this.storage.setIdToken(oidcIdToken);
            _this.storage.state.remove();
            _this.storage.nonce.remove();
            var redirectUrl = params.get('redirectUrl');
            if (typeof redirectUrl === 'string') {
                window.location.href = redirectUrl;
            }
        };
        this.validateIdToken = function (token) {
            if (token.getClaim('nonce') !== _this.storage.nonce.get()) {
                throw new Error("Auth - incorrect nonce");
            }
        };
        this.validateParams = function (params) {
            var errorParam = params.get('error');
            var stateParam = params.get('state');
            var accessTokenParam = params.get(_this.ACCESS_TOKEN);
            if (errorParam !== null) {
                throw new Error("Auth - " + errorParam);
            }
            if (stateParam !== _this.storage.state.get()) {
                throw new Error("Auth - incorrect state");
            }
            if (accessTokenParam === null) {
                throw new Error("Auth - missing token");
            }
        };
    }
    return OidcUrlHelper;
}());

var TokenStorage = /** @class */ (function () {
    function TokenStorage() {
        var _this = this;
        this.token = new SessionValue(TokenStorage_1.TOKEN_PARAM);
        this.getToken = function () { var _a; return (_a = _this.token.get()) !== null && _a !== void 0 ? _a : null; };
        this.setToken = function (oidcToken) {
            _this.token.set(oidcToken);
            return _this;
        };
    }
    TokenStorage_1 = TokenStorage;
    var TokenStorage_1;
    TokenStorage.TOKEN_PARAM = 'AuthToken';
    TokenStorage = TokenStorage_1 = __decorate([
        singleton
    ], TokenStorage);
    return TokenStorage;
}());

var TokenClient = /** @class */ (function () {
    function TokenClient(params) {
        this.storage = new TokenStorage();
        this.timeout = null;
        this.isTimeoutSet = false;
        this.tokenData = null;
        this.tokenRequest = null;
        this.params = params;
    }
    TokenClient_1 = TokenClient;
    TokenClient.prototype.bindTokenUpdated = function (handler) {
        document.addEventListener(TokenClient_1.TOKEN_UPDATED_EVENT, handler);
        return this;
    };
    TokenClient.prototype.unbindTokenUpdated = function (handler) {
        document.removeEventListener(TokenClient_1.TOKEN_UPDATED_EVENT, handler);
        return this;
    };
    TokenClient.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isTokenRefreshed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshToken()];
                    case 1:
                        isTokenRefreshed = _a.sent();
                        return [2 /*return*/, isTokenRefreshed ? this.tokenData : null];
                }
            });
        });
    };
    TokenClient.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isTokenValid, tokenData, event_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.tokenData) {
                            this.tokenData = this.storage.token.get();
                        }
                        isTokenValid = !!this.tokenData && !this.hasTokenExpired(this.tokenData);
                        if (!!isTokenValid) return [3 /*break*/, 2];
                        if (this.tokenData) {
                            this.removeTokenFromStorage();
                        }
                        return [4 /*yield*/, this.requestToken()];
                    case 1:
                        tokenData = _a.sent();
                        this.saveTokenToStorage(tokenData);
                        event_1 = new CustomEvent(TokenClient_1.TOKEN_UPDATED_EVENT, {
                            detail: {
                                tokenData: this.tokenData,
                            },
                        });
                        document.dispatchEvent(event_1);
                        _a.label = 2;
                    case 2:
                        this.setRefreshTimeout(this.tokenData);
                        return [2 /*return*/, true];
                }
            });
        });
    };
    TokenClient.prototype.requestToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.tokenRequest) {
                            this.tokenRequest = fetch(this.params.url, TokenClient_1.REQUEST_OPTIONS);
                        }
                        return [4 /*yield*/, this.tokenRequest];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error(response.status + " " + response.statusText);
                        }
                        result = response.json();
                        return [2 /*return*/, result];
                    case 2:
                        error_1 = _a.sent();
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        throw new Error("Token request has failed: " + error_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TokenClient.prototype.setRefreshTimeout = function (tokenData) {
        var _this = this;
        if (this.isTimeoutSet || !tokenData) {
            return;
        }
        this.isTimeoutSet = true;
        if (this.timeout !== null) {
            window.clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isTimeoutSet = false;
                        this.tokenRequest = null;
                        return [4 /*yield*/, this.refreshToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, this.getTokenRefreshTime(tokenData));
    };
    TokenClient.prototype.removeTokenFromStorage = function () {
        this.tokenData = null;
        this.storage.token.remove();
    };
    TokenClient.prototype.saveTokenToStorage = function (tokenData) {
        this.tokenData = tokenData;
        this.storage.token.set(tokenData);
    };
    TokenClient.prototype.getTokenRefreshTime = function (tokenData) {
        var expirationDate = Date.parse(tokenData.ExpirationDate);
        var currentDate = Date.now();
        var timeToRefresh = expirationDate - currentDate;
        if (timeToRefresh <= 0) {
            timeToRefresh = TokenClient_1.TOKEN_REQUEST_INTERVAL;
        }
        return timeToRefresh;
    };
    TokenClient.prototype.hasTokenExpired = function (tokenData) {
        var expirationDate = Date.parse(tokenData.ExpirationDate);
        return expirationDate <= Date.now();
    };
    var TokenClient_1;
    TokenClient.REQUEST_OPTIONS = {
        credentials: 'same-origin',
        headers: {
            'X-Fetch-Api': '1',
            'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
    };
    TokenClient.TOKEN_REQUEST_INTERVAL = 30000;
    TokenClient.TOKEN_UPDATED_EVENT = 'tokenUpdated';
    TokenClient = TokenClient_1 = __decorate([
        singleton
    ], TokenClient);
    return TokenClient;
}());

export { OidcAccessToken, OidcClient, OidcIdToken, OidcTokenStorage, OidcUrlHelper, TokenClient, TokenStorage };
//# sourceMappingURL=index.esm.js.map
